import React, { useState, useEffect } from "react";
import classes from "./ruleassignmentssearch.module.scss";
import { FormControl, TextField, Button, Grid,Box } from "@mui/material";
import { Icon, DatePicker } from "@genesis/ui-kit";
import axios from "axios";
import axiosInstance from "../../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { CheckIsUserAdmin,} from "../../../../../Shared/Utill/Utills";
import SnackBar from "../../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../../DivisionDropdown/DivisionDropdownComp";
import {
  AddPlusIcon,
  SearchIcon,
} from "../../../../../Resources/availabilityicon/IconUtils";
import AdminControlsDataGrid from "../../../AdminControlsDataGrid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import delete_disable from "../../../../../Resources/delete_disable.png";
import { constants } from "../../../../../Shared/Url/Constants";
import DeleteRuleAssignmentDialog from "../Delete/DeleteRuleAssignmentDialog";
import { isNull } from "underscore";

const RuleAssignmentsSearch = () => {
  const personDetails = useSelector(
    (state) => state.personStatic.personStaticData
  );
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookies.get("X_TKN");
  const history = useNavigate();
  const [divSelectedValue, setDivSelectedValue] = useState(null);
  const [searchLocation, setSearchLocation] = useState(null);
  const [scheduleArea, setScheduleArea] = useState(null);
  const [groupId, setGroupId] = useState(null);
  const [ruleId, setRuleId] = useState(null);

  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const location = useLocation();
  const [searchValue, setSearchValue] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [aRaID, setARaID] = useState(null);

  // check user role at page
  CheckIsUserAdmin();

  useEffect(() => {
    let isDeleteSuccess = location.state !== null ? true : false;
    if(isDeleteSuccess){
      setAlertOpen({
        open: true,
        severity:  'success',
        message : location.state.message,
      })
    }
  },[]);

  const onDivDropDownSelect = (selectedDivision) => {
    setDivSelectedValue(selectedDivision);
  };

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const columns = [
    { field: 'recordid', headerName: 'Record ID', width: "100" },
    { field: 'division', headerName: 'Division', width: "220" },
    { field: 'location', headerName: 'Location', width: "100" },
    { field: 'schedule_area', headerName: 'Schedule Area', width: "150" },
    { field: 'groupid', headerName: 'Group ID', width: "100" },
    { field: 'ruleid', headerName: 'Rule ID', width: "100" },
    { field: 'actions', headerName: 'Actions', width: "180", renderCell: (params) => {  
      console.log("edit rule assign",params.row.id)
      let isDeleteDisable = params.row.location == "0" && params.row.schedule_area == "0";
      let delColor = isDeleteDisable ? "gray2" : "gray";
      return( <div>
         <NavLink
            to="Edit"
            style={{ textDecoration: "underline" }}
            state={{ flag: "E", id: params.row.id , isSearch: true}}
            className={classes.label_text}>
                <EditIcon />
        </NavLink>
        <DeleteOutlineIcon color={delColor} onClick={isDeleteDisable ? null : ()=> onDeleteAction(params.row.id)} />
        </div>)
      }},
    ];

  //------
  const handleSearch = () => {
    if(divSelectedValue == null){
      setAlertOpen({
        open: true,
        severity: 'error',
        message: 'Please select Division',
    });
    return;
    }
 // data for searching
 let data = {
  divNbr: divSelectedValue.divNbr,
  groupId: groupId,
  locNbr: searchLocation,
  dptNbr: scheduleArea,
  ruleId: ruleId
} 

axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVLL_RULE_ASSIGN_SEARCH}`, 
data,
{
 headers:{
 'Content-Type': 'application/json',
 'Authorization':'Bearer ' + token,
 }
}).then((res) => {
 
 let tmparr = []
 console.log("response",res.data);
 res.data.map(obj => {
    let tmpobj = {}
    tmpobj.id = obj.araId;
    tmpobj.recordid = obj.araId;
    tmpobj.division = obj.divNameDisplay;
    tmpobj.location = obj.locNbr;
    tmpobj.schedule_area = obj.dptNbr;
    tmpobj.groupid = obj.groupId;
    tmpobj.ruleid = obj.ruleId;

    tmparr.push(tmpobj);
   
 });
 setSearchValue(tmparr);
}).catch((err) => {
 if(err.message === 'Network Error') {
   history("/somethingwentwrong", {state:`Please logout and try again `})
 }else {
   history("/somethingwentwrong", {state:`${constants.WFM_AVLL_RULE_ASSIGN_SEARCH}...failed`})
   }
});

  };

  //-- delete
  const onCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  const onDeleteCallback = (responseType, message) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message: message,
    });
    // refresh data
    if (responseType == "success") {
      // refresh handle search
      handleSearch();
    }
  };
 
  const onDeleteAction = (araId) => {
    //set current selected delete item
    setARaID(araId);
    setOpenDeleteDialog(true);
  };

  return (
    <div className={classes.pagemargin}>
        <AllControlSearchView/>
      <div className={classes.pagetitle}>Rule Assignments</div>
      <div className={classes.icon_text_wrap}>
        <div className={classes.icon_text}>
          <AddPlusIcon />
          <NavLink
            to={"Add"}
            style={{ textDecoration: "underline" }}
            state={{ flag: "A", isSearch: true }}
            className={classes.label_text}
          >
            Add
          </NavLink>
        </div>
      </div>

      <div className={classes.searchbox}>
        <SnackBar
          open={open}
          message={message}
          severity={severity}
          onClose={handleAlertNotifClose}
        ></SnackBar>

        <Grid container spacing={3}>
          <Grid key={0} item xs={2}>
            <DivisionDropDownComp
              onDivChange={(e) => onDivDropDownSelect(e)}
            ></DivisionDropDownComp>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Location (Opt)"
                onChange={(e) => setSearchLocation(e.target.value)}
                value={searchLocation}
              />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Schedule Area (Opt)"
                onChange={(e) => setScheduleArea(e.target.value)}
                value={scheduleArea}
              />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Group ID (Opt)"
                onChange={(e) => setGroupId(e.target.value)}
                value={groupId}
              />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Rule ID (Opt)"
                onChange={(e) => setRuleId(e.target.value)}
                value={ruleId}
              />
            </FormControl>
          </Grid>
          <Grid key={2} item xs={2}>
            <Button
              style={{
                marginLeft: "10px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "80px",
                paddingRight: "80px",
                marginRight: "5px",
              }}
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </div>
      <AdminControlsDataGrid columns= { columns} rows = {searchValue} width={"90%"}   />  
      {openDeleteDialog && (
          <DeleteRuleAssignmentDialog
            onCloseDialog={onCloseDialog}
            onDeleteCallback={onDeleteCallback}
            data={aRaID}
          />
        )}
    </div>
  );
};

export default RuleAssignmentsSearch;

export const AllControlSearchView = (props) => {
  return(<div className={classes.icon_text_wrap}>
  <div className={classes.icon_text}>
    <SearchIcon />
    &nbsp;
    <NavLink
      to="/controls/availabilityapplicationcontrols/advancesearch"
      style={{ textDecoration: "underline" }}
      className={classes.label_text}
    >
      All Controls Search
    </NavLink>
  </div>
</div>);
}